import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useParams } from 'react-router';
import { API, Auth } from 'aws-amplify';

import { buttonsReset } from 'src/store/modules/buttons';
import { customlogReset } from 'src/store/modules/customlog';
import { editTextReset } from 'src/store/modules/editText';
import { imageReset } from 'src/store/modules/imageUpload';
import { pagesReset } from 'src/store/modules/pages';

import setInitValue from 'src/utils/setInitValue';
import { changeEnter } from 'src/utils/changeEnter';
import { initTrackingValues } from '../TemplateTracking/ListModalTracking';
import { editUserCompany } from 'src/store/modules/client';
import { trackingReset } from 'src/store/modules/trackings';

const TEXT_2_JUSTIFY = {
  left: 'start',
  center: 'center',
  right: 'end'
};

const initViewValues = {
  currentIndex: 0,
  bgColor: { background: '#fff' },
  radius: { background: 16, button: 0 },

  text: {
    title: 'Automatic renewal',
    multi_text: [
      "To view your current subscriptions and cancel, go to 'Settings' on your iPhone or iPad.",
      "Touch your ID at the top of the screen, then 'Subscriptions,' and select 'Onoff' to modify or cancel.",
      'As a reminder, porting a number, deleting a number, or even an account does not cancel an automatic renewal subscription.'
    ]
  },
  fontSize: { title: 1.25, multi_text: 0.75 },
  fontWeight: { title: 700, multi_text: 400 },
  color: { title: '#000000', multi_text: '#000000' },
  fontFamily: { title: 'Poppins', multi_text: 'Poppins' },
  textAlign: { title: 'center', multi_text: 'left' },

  btnText: {
    button: 'Confirm',
    sub_button: '닫기',
    never_show_button: '다시 보지 않기'
  },
  btnFontSize: { button: 1, sub_button: 0.875, never_show_button: 0.875 },
  btnFontWeight: { button: 700, sub_button: 500, never_show_button: 500 },
  btnColor: {
    button: '#ffffff',
    sub_button: '#ffffff',
    never_show_button: '#ffffff'
  },
  btnBgColorR: { button: 0, sub_button: 0, never_show_button: 0 },
  btnBgColorG: { button: 0, sub_button: 0, never_show_button: 0 },
  btnBgColorB: { button: 0, sub_button: 0, never_show_button: 0 },
  btnBgColorA: { button: 1, sub_button: 0, never_show_button: 0 },
  btnFontFamily: {
    button: 'Roboto',
    sub_button: 'Roboto',
    never_show_button: 'Roboto'
  }
};

const ListModal: FC = () => {
  const dispatch = useDispatch();

  var templateWidth = useSelector((state: any) => state.template.templateWidth);

  var bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);

  var radius = useSelector((state: RootState) => state.imageUpload.radius);

  var text = useSelector((state: RootState) => state.editText.text);
  var fontSize = useSelector((state: RootState) => state.editText.fontSize);
  var fontWeight = useSelector((state: RootState) => state.editText.fontWeight);
  var color = useSelector((state: RootState) => state.editText.color);
  var fontFamily = useSelector((state: RootState) => state.editText.fontFamily);
  var textAlign = useSelector((state: RootState) => state.editText.textAlign);

  var btnText = useSelector((state: RootState) => state.buttons.btnText);
  var btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  var btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  var btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  var btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  var btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  var btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  var btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  var btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );

  useEffect(() => {
    async function getUserId() {
      try {
        const current = await Auth.currentUserInfo();
        dispatch(editUserCompany(current.attributes['custom:Company']));
      } catch (error) {
        console.log('error');
      }
    }
    getUserId();
  }, []);

  const style = `
  .root_view {
    width: 100%;
    height: 100%;
    
    position: relative;
    background: none;
    overflow: hidden;
    
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center {
      width: 80%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      display: flex;
      flex-direction: column;
      gap: 2rem;
    }
    .modal_wrapper {
      width: 100%;
      padding: 2rem 1rem;

      display: flex;
      flex-direction: column;
      gap: 1rem;
      
      border-radius: ${radius?.background}px;
      background-color: ${bgColor?.background};
    }

    .title {
      height: 3rem;
      display: flex;
      align-items: center;
    }
    .title_inner {
      width: 100%;
      height: auto;
      max-height: 3rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.title};
      color: ${color?.title};
      font-size: ${fontSize?.title}rem;
      font-weight: ${fontWeight?.title};
      font-family: ${fontFamily?.title};
    }

    .middle_wrapper {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
    }
    .middle_text_wrapper {
      height: 4rem;
      display: flex;
      align-items: center;
      overflow: hidden;
    }
    .middle_text_wrapper .middle_number {
      max-width: 3rem;
      min-width: 3rem;
      max-height: 3rem;
      min-height: 3rem;

      display: flex;
      justify-content: center;
      align-items: center;

      font-size: 1.25rem;
      font-weight: 700;
    }
    .middle_text_wrapper .middle_text {
      height: 4rem;
      display: flex;
      align-items: center;
      justify-content: ${TEXT_2_JUSTIFY[textAlign?.multi_text]};
    }
    .middle_text_inner {
      height: auto;
      max-height: 4rem;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 4;

      text-align: ${textAlign?.multi_text};
      color: ${color?.multi_text};
      font-size: ${fontSize?.multi_text}rem;
      font-weight: ${fontWeight?.multi_text};
      font-family: ${fontFamily?.multi_text};
    }

    .btn_wrapper {
      width: 100%;
      padding: 0 1rem;
    }
    .btn_wrapper button {
      width: 100%;
      height: 3rem;
      outline: 0;
      border: 0;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      font-size: ${btnFontSize?.button}rem;
      font-weight: ${btnFontWeight?.button};
      color: ${btnColor?.button};
      font-family: ${btnFontFamily?.button} !important;

      border-radius: ${radius?.button}px;
      background-color:rgba(${btnBgColorR?.button},${btnBgColorG?.button}, ${
    btnBgColorB?.button
  }, ${btnBgColorA?.button});
    }

    .bottom_wrapper {
      height: 1.25rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .bottom_input {
      width: 1.25rem;
      height: 1.25rem;
    }
    .bottom_wrapper .style01 {
      width: 100%;
      display: flex;
      align-items: center;
      gap: 0.5rem;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.never_show_button};
      font-weight: ${btnFontWeight?.never_show_button};
      font-size: ${btnFontSize?.never_show_button}rem;
      font-family: ${btnFontFamily?.never_show_button};
      background-color:rgba(${btnBgColorR?.never_show_button},${
    btnBgColorG?.never_show_button
  }, ${btnBgColorB?.never_show_button}, ${btnBgColorA?.never_show_button});
    }
    .bottom_wrapper .style02 {
      width: 100%;
      text-align: right;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      color: ${btnColor?.sub_button};
      font-weight: ${btnFontWeight?.sub_button};
      font-size: ${btnFontSize?.sub_button}rem;
      font-family: ${btnFontFamily?.sub_button};
      background-color:rgba(${btnBgColorR?.sub_button},${
    btnBgColorG?.sub_button
  }, ${btnBgColorB?.sub_button}, ${btnBgColorA?.sub_button});
    }

    ${
      templateWidth < 331
        ? `
        .modal_wrapper {
          gap: 0.5rem;
        }
        .middle_text_wrapper .middle_number {
          max-width: 2rem;
          min-width: 2rem;
          max-height: 2rem;
          min-height: 2rem;
        }

        .btn_wrapper {
          margin-top: 0.5rem;
        }
        `
        : ``
    }

    ${
      templateWidth > 767
        ? `
        .center {
          width: 50%;
        }
        .modal_wrapper {
          padding: 2rem;
        }

        .title {
          height: 4rem;
        }
        .title_inner {
          max-height: 4rem;
          font-size: ${fontSize?.title + 0.375}rem;
        }

        .middle_text_wrapper .middle_text {
          height: 5rem;
        }
        .middle_text_inner {
          max-height: 5rem;
          font-size: ${fontSize?.multi_text + 0.05}rem;
        }

        .btn_wrapper {
          margin-top: 1rem;
        }
        `
        : ``
    }
  }
  `;

  const { id } = useParams<{ id: string }>();
  useEffect(() => {
    async function onLoad() {
      try {
        if (id) {
          const { customValues } = await API.get(
            'iam-editor',
            `/templates/${id}`,
            ''
          );
          setInitValue(dispatch, customValues);
        }
      } catch (error) {}
    }
    setInitValue(dispatch, { ...initViewValues, ...initTrackingValues });
    onLoad();
    return () => {
      dispatch(buttonsReset());

      dispatch(editTextReset());
      dispatch(imageReset());
      dispatch(pagesReset());

      dispatch(customlogReset());
      dispatch(trackingReset());
    };
  }, []);

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }}></style>
      <div className="root_view">
        <div className="background"></div>
        <div className="center">
          <div className="modal_wrapper">
            <div className="title">
              <div className="title_inner">{changeEnter(text?.title)}</div>
            </div>
            <div className="middle_wrapper">
              {text?.multi_text?.map((text: string, idx: number) => {
                return (
                  <div key={idx} className="middle_text_wrapper">
                    <p className="middle_number">{idx + 1}</p>
                    <p className="middle_text">
                      <div className="middle_text_inner">
                        {changeEnter(text)}
                      </div>
                    </p>
                  </div>
                );
              })}
            </div>
            <div className="btn_wrapper">
              <button>{btnText?.button}</button>
            </div>
          </div>
          <div className="bottom_wrapper">
            <span className="style01">
              <input
                className="bottom_input"
                type="checkbox"
                value="never-show"
                name="never-show"
              />
              <span>{btnText?.never_show_button}</span>
            </span>
            <span className="style02">{btnText?.sub_button}</span>
          </div>
        </div>
      </div>
    </>
  );
};
export default ListModal;
